<template>
  <div class="wrap1 form-wrap">
    <h1 class="common-title">
      <i class="el-icon-arrow-left" @click="$emit('doSubmit', 1)"></i>
      {{ $t('1380') }}
    </h1>
    <div class="wrap1-content scheduling-content">
      <!-- settings -->
      <el-form :model="form" status-icon label-width="100px" label-position="left">
        <!-- 考勤班次 -->
        <el-form-item :label="$t('1381')" prop="pass">
          <div class="select-scheduling">
            <span
              class="scheduling"
              v-for="(item, index) in scheduling"
              :key="index"
              :style="{ background: item.color }"
              @click="selectSchOpen"
              >{{ item.name }}</span
            >
            <i class="el-icon-circle-plus-outline" @click="selectSchOpen"></i>
          </div>
        </el-form-item>
        <!-- 排班周期 -->
        <el-form-item :label="$t('1382')" prop="checkPass">
          <el-button
            type="text"
            @click="$refs.setting.init(scheduling, null, { groupId, cycleId: cycle.id })"
            v-if="cycle.groups && cycle.groups.length < 1"
          >
            {{ $t('1383') }}
          </el-button>
          <el-table :data="cycle.groups" class="my-table" :cell-style="cellStyle" v-else>
            <el-table-column prop="group_name" :label="$t('1345')" width="180" align="center"> </el-table-column>
            <el-table-column
              align="center"
              v-for="(item, index) in Number(cycle.num) || 0"
              :key="index"
              :label="`${index + 1}`"
              width="60px"
            >
              <template slot-scope="scope">{{ handlerSlice(scope.row[index + 1].name) }}</template>
            </el-table-column>
            <el-table-column> </el-table-column>
            <el-table-column :label="$t('70')" width="200">
              <template slot-scope="scope">
                <el-button type="text" @click="handlerSelectPerson(scope.row)">{{ $t('177') }}</el-button>
                <el-button
                  type="text"
                  @click="$refs.setting.init(scheduling, cycle.shifts, { groupId, cycleId: cycle.id })"
                  >{{ $t('63') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 选择月份 -->
        <el-form-item :label="$t('634')" prop="age" class="search">
          <div class="search-content">
            <div class="search-left">
              <el-date-picker v-model="form.month" type="month" @change="getRoundInfo"> </el-date-picker>
              <!-- 生成考勤日历 -->
              <el-button type="primary" class="create-date" @click="handlerCreateDate">
                {{ $t('1743') }}
              </el-button>
              <div class="save-button" v-if="editGroups.length">
                <span>{{ $t('1394') }}： {{ this.$t('1777', { n: editGroups.length }) }} </span>
                <el-button type="primary" class="create-date" @click="handlerDayCancel" :disabled="loading">
                  {{ $t('1395') }}
                </el-button>
                <el-button type="primary" class="create-date" @click="handlerDaySave" :loading="loading">
                  {{ $t('67') }}
                </el-button>
              </div>
              <!-- 搜索人 -->
              <div class="search-input">
                <staff-search comment="comment" size="" @change="staffChange" />
                <i class="el-icon-search"></i>
              </div>
            </div>
            <div class="search-right">
              <el-button type="primary" class="create-date" @click="handleExport">
                {{ $t('68') }}
              </el-button>
              <el-button type="primary" class="create-date" @click="openUpload">
                {{ $t('14') }}
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- 考勤日历 -->
      <el-table :data="tableData.datalist" border style="width: 100%" :cell-style="dateCellStyle">
        <el-table-column prop="staff_name" :label="$t('1345')" fixed="left" align="center" width="150">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableData.days" :key="index + item.week" width="60" align="center">
          <template slot="header">
            <!-- 公共假期提示文案 -->
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.holiday_name"
              placement="top-start"
              v-if="item.is_holiday"
            >
              <div :style="{ color: item.is_holiday ? '#EA6D74' : '#909399' }">
                <span>{{ item.day }}</span>
                <br />
                <span>{{ item.week }}</span>
              </div>
            </el-tooltip>
            <div v-else>
              <span>{{ item.day }}</span>
              <br />
              <span>{{ item.week }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <!-- 根据disabled判断是否展示弹窗 -->
            <el-popover
              width="400"
              trigger="click"
              v-if="createData(scope.row, item) && !createData(scope.row, item)['disabled']"
              :ref="`popover-${scope.$index}-${item.day}`"
            >
              <div style="max-height: 240px; overflow: auto">
                <el-button
                  v-for="(i, num) in scheduling"
                  :key="num"
                  :style="{ background: i.color || '#FFF', width: '100%', margin: '5px 0', color: '#FFF' }"
                  @click="
                    handlerChangeSch({
                      day: item.day,
                      data: scope.row,
                      staff_id: scope.row.staff_id,
                      shift_id: i.shift_id,
                      shift: i,
                      key: `popover-${scope.$index}-${item.day}`
                    })
                  "
                >
                  {{ i.name }}</el-button
                >
              </div>
              <span slot="reference" :class="handlerClass(scope.row, item)">{{
                handlerSlice(createData(scope.row, item) ? createData(scope.row, item)['name'] : '')
              }}</span>
            </el-popover>
            <span
              v-else
              :style="{
                opacity: createData(scope.row, item) && createData(scope.row, item)['is_opacity'] ? '0.4' : '1'
              }"
              >{{ handlerSlice(createData(scope.row, item) ? createData(scope.row, item)['name'] : '') }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagina.page"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="pagina.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagina.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 选择班次 -->
    <select-sch ref="selectSch" @change="schSelect" :p="p" />
    <!--  周期设置 -->
    <setting-scheduling ref="setting" @update="getRoundInfo" />
    <!-- 人员选择 -->
    <select-person ref="selectPerson" @update="getRoundInfo" />
    <!-- 选择开始月份 生成表格 -->
    <select-date ref="selectDate" @update="getRoundInfo" />
    <!-- 批量导入 -->
    <batchUpload ref="batchUpload" :fileSize="10" @doSubmit="doSubmit" />
  </div>
</template>

<script>
// 选择班次
import SelectSch from './select-scheduling'
// 选择周期
import settingScheduling from './setting-scheduling'
// 选择人员
import SelectPerson from './select-person.vue'
// 选择开始月份 生成表格
import SelectDate from './select-date.vue'
import staffSearch from '_c/staff-search'
import batchUpload from '_c/batch-upload'
import {
  round_info,
  round_add_shift,
  round_add_staff_shift,
  exportStaffShift,
  downloadStaffShiftTpl
} from 'api/Attendance'

export default {
  components: {
    SelectSch,
    settingScheduling,
    SelectPerson,
    SelectDate,
    staffSearch,
    batchUpload
  },
  props: {
    p: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        month: new Date(),
        staff_id: ''
      },
      groupId: '', // 考勤组id
      tableData: [],
      scheduling: [], // 已选班次
      roundTable: [], // 周期表格
      // 班次信息
      cycle: {
        groups: [],
        num: 0
      },
      pagina: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false, // 数据保存loading
      editGroups: [] // 编辑几项
    }
  },
  created() {
    this.init()
  },
  computed: {
    // 生成日期可是key
    dateKey() {
      const { month } = this.form
      if (!month) return ''
      return this.$util.parseTime(month, '{y}-{m}')
    }
  },
  methods: {
    init(groupId) {
      this.groupId = groupId
      this.$nextTick(() => this.getRoundInfo())
    },
    // 只展示俩位
    handlerSlice(str) {
      str = String(str)
      return str.slice(0, 2)
    },
    // 选择人员
    handlerSelectPerson(row) {
      const msg = {
        id: this.groupId,
        cycle_id: this.cycle.id,
        group_id: row.group_id
      }
      this.$refs.selectPerson.init(msg)
    },
    handlerClass(row, item) {
      const currentData = this.createData(row, item)
      if (currentData.isEdit) return 'modified'
    },
    // 单项数据修改
    handlerChangeSch(params) {
      let { key, day, data, shift } = params
      day = day <= 9 ? '0' + day : day
      params.date_at = `${this.dateKey}-${day}`
      const target = data[params.date_at]
      if (target) {
        target.color = shift.color
        target.name = shift.name
        target.isEdit = true
      }
      let status = true
      // 去重
      this.editGroups.forEach(element => {
        if (element.day === params.day && element.staff_id === params.staff_id) {
          element.shift_id = params.shift_id
          status = false
        }
      })
      // 去重之后添加
      if (status) this.editGroups.push(params)
      this.$refs[key][0].doClose()
    },
    // 导出
    handleExport() {
      exportStaffShift({
        id: this.groupId,
        month: this.dateKey,
        staff_id: this.form.staff_id
      }).then(res => {
        window.open(res.data)
      })
    },
    openUpload() {
      const data = {
        title: this.$t('i18n.560e1c94a4d74e6ea0a94d6c8a3acd62'),
        list: {
          1: {
            name: this.$t('bulkImport'),
            label: '1',
            tip: this.$t('46'),
            download: this.$t('47'),
            download_text: this.$t('778'),
            download_api: downloadStaffShiftTpl,
            query: {
              id: this.groupId,
              month: this.dateKey
            },
            upload: this.$t('39'),
            upload_text: this.$t('728'),
            upload_tip: this.$t('40'),
            upload_api: '/web/attendance/updateStaffShift',
            type: '2',
            emit: true
          },
          2: {
            name: this.$t('batch_update'),
            label: '2',
            tip: this.$t('46'),
            download: this.$t('i18n.724568c9fe4a45e5839815df5b53d10e'),
            download_text: this.$t('1373'),
            download_api: exportStaffShift,
            query: {
              id: this.groupId,
              month: this.dateKey
            },
            upload: this.$t('39'),
            upload_text: this.$t('728'),
            upload_tip: this.$t('40'),
            upload_api: '/web/attendance/updateStaffShift',
            type: '2',
            emit: true
          }
        }
      }
      this.$refs.batchUpload.init(data)
    },
    doSubmit() {
      this.getRoundInfo()
    },
    // 搜索人员
    staffChange(val) {
      this.form.staff_id = val.staff_id
      this.getRoundInfo()
    },
    // 生成考勤日历
    handlerCreateDate() {
      // 如果是当前月则切换到当前天 反之为每月一号
      const month = new Date().getMonth()
      if (month === this.form.month.getMonth()) this.form.month = new Date()
      this.$refs.selectDate.init({
        id: this.groupId,
        date: this.form.month
      })
    },
    // 按天排班恢复
    handlerDayCancel() {
      this.editGroups = []
      this.getRoundInfo()
    },
    // 按天排班保存
    handlerDaySave() {
      const msg = {
        id: this.groupId, // 考勤组id
        data: this.editGroups
      }
      this.loading = true
      round_add_staff_shift(msg)
        .then(() => {
          this.editGroups = []
          this.getRoundInfo()
        })
        .finally(() => (this.loading = false))
    },
    // 表格文案
    createData(row, item) {
      return row[`${this.dateKey}-${item.day < 10 ? '0' + item.day : item.day}`]
    },
    // 单元格颜色
    cellStyle(params) {
      const { columnIndex, row } = params
      const data = row[columnIndex]
      if (data && data.color) return { background: data.color, color: '#FFFFFF' }
    },
    // 日历单元格颜色
    dateCellStyle(params) {
      const { columnIndex, row } = params
      const keyIndex = this.tableData.days[columnIndex - 1]
      if (keyIndex && keyIndex.day) {
        const currentData = this.createData(row, keyIndex)
        if (currentData && currentData.color) {
          return { background: currentData.color, color: '#FFFFFF' }
        }
      }
    },
    // 获取排班详情
    getRoundInfo() {
      if (!this.dateKey) return
      const query = {
        id: this.groupId,
        month: this.dateKey,
        ...this.pagina
      }
      if (this.form.staff_id) query.staff_id = this.form.staff_id
      round_info(query).then(res => {
        const { data } = res
        this.cycle = data.cycle
        this.scheduling = data.shifts
        this.tableData = data.staffs
        this.pagina.total = data.staffs.count
      })
    },
    // 分页相关
    handleSizeChange(val) {
      this.pagina.page = 1
      this.pagina.size = val
      this.getRoundInfo()
    },
    handleCurrentChange(val) {
      this.pagina.page = val
      this.getRoundInfo()
    },
    // 选择班次弹窗开启
    selectSchOpen() {
      this.$refs.selectSch.init(null, true, this.scheduling)
    },
    // 日期选择限制
    // disabledDate(t) {
    //   return t.getMonth() < month
    // },
    // change添加
    schSelect(data) {
      this.scheduling = data
      round_add_shift({
        id: this.groupId,
        shift_ids: data.map(item => item.id)
      }).then(() => {
        this.getRoundInfo()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  overflow: hidden;
  &-content {
    height: calc(100% - 48px);
    overflow-y: auto;
    background: #fff;
    padding: 24px 24px 52px 24px;
  }
}
.search {
  margin-bottom: 0px;
  &-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  &-left {
    margin-bottom: 20px;
  }
  &-right {
    margin-bottom: 20px;
  }
  &-input {
    display: inline-block;
    margin-left: 10px;
    position: relative;
    .el-icon-search {
      position: absolute;
      font-size: 14px;
      color: #c0c4cc;
      left: 10px;
      bottom: 11px;
    }
    /deep/ .el-input__inner {
      padding-left: 30px;
    }
  }
}
/deep/ .el-table__header th {
  background-color: #ebebeb !important;
}
/deep/ .el-popover__reference {
  cursor: pointer;
}
/deep/ .el-popover__reference-wrapper {
  cursor: pointer;
}
.create-date {
  margin-left: 20px;
}
.scheduling-content {
  margin-top: 12px;
}
.modified {
  border: 1px solid #fff;
  padding: 0 2px;
}

.select-scheduling {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: inline-block;
  min-width: 300px;
  padding: 12px 12px 0 12px;
  transform: translateY(-10px);
  transition: all 0.3s;
  &:hover {
    border-color: #c9ccd1;
  }
  &:active {
    border-color: $theme;
  }
  .scheduling {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    padding: 0 8px;
    user-select: none;
    display: inline-block;
    border-radius: 2px;
    color: white;
    margin: 0 12px 17px 0;
    cursor: pointer;
  }
  .el-icon-circle-plus-outline {
    font-size: 22px;
    transform: translateY(4px);
    color: $theme;
    cursor: pointer;
    &:hover {
      color: rgba($theme, 0.5);
    }
    &:active {
      color: $theme;
    }
  }
}
.common-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  width: calc(100% + 50px);
  transform: translateX(-25px) translateY(-2px);
  padding: 0 25px 12px 25px;
  font-size: 14px;
  user-select: none;
  margin-bottom: 22px;
  .el-icon-arrow-left {
    cursor: pointer;
  }
  &::before {
    display: none;
  }
}
.save-button {
  float: right;
  // transform: translateY(-50px);
}
</style>
